"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UUPSUpgradeable__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "address",
    name: "target",
    type: "address"
  }],
  name: "AddressEmptyCode",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "ERC1967InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "ERC1967NonPayable",
  type: "error"
}, {
  inputs: [],
  name: "FailedCall",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [],
  name: "UUPSUnauthorizedCallContext",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "slot",
    type: "bytes32"
  }],
  name: "UUPSUnsupportedProxiableUUID",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "Upgraded",
  type: "event"
}, {
  inputs: [],
  name: "UPGRADE_INTERFACE_VERSION",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "proxiableUUID",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "upgradeToAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}];
class UUPSUpgradeable__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.UUPSUpgradeable__factory = UUPSUpgradeable__factory;
_defineProperty(UUPSUpgradeable__factory, "abi", _abi);